import { render } from "./NatureDropdown.vue?vue&type=template&id=774510b5&scoped=true"
import script from "./NatureDropdown.vue?vue&type=script&lang=js"
export * from "./NatureDropdown.vue?vue&type=script&lang=js"

import "./NatureDropdown.vue?vue&type=style&index=0&id=774510b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774510b5"]])

export default __exports__